// Reducción de fotos EN EL NAVEGADOR antes de subirlas: el Camino tiene mala cobertura y una
// foto de móvil pesa 3–8 MB. El backend la sanea igualmente (quita EXIF, valida, WebP).

export const MAX_UPLOAD_DIMENSION = 2000
const JPEG_QUALITY = 0.85

export const fitInside = (width: number, height: number, max: number): { width: number; height: number } => {
	const scale = Math.min(1, max / Math.max(width, height))
	return { width: Math.max(1, Math.round(width * scale)), height: Math.max(1, Math.round(height * scale)) }
}

// Las operaciones del navegador, inyectables para poder probar la lógica sin canvas real.
export type ImageCodec = {
	decode(file: Blob): Promise<{ width: number; height: number; source: CanvasImageSource; close(): void }>
	encode(source: CanvasImageSource, size: { width: number; height: number }, quality: number): Promise<Blob>
}

export const browserCodec: ImageCodec = {
	async decode(file) {
		// `imageOrientation: from-image` endereza la foto según su EXIF antes de redibujarla.
		const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' })
		return { width: bitmap.width, height: bitmap.height, source: bitmap, close: () => bitmap.close() }
	},
	async encode(source, { width, height }, quality) {
		const canvas = new OffscreenCanvas(width, height)
		const context = canvas.getContext('2d')
		if (!context) throw new Error('Canvas no disponible')
		context.drawImage(source, 0, 0, width, height)
		return canvas.convertToBlob({ type: 'image/jpeg', quality })
	},
}

// Devuelve una JPEG reducida. Si el navegador no puede (formato no soportado, sin canvas…),
// devuelve el archivo original: subir de más es mejor que no poder avisar.
export const resizeImage = async (file: Blob, codec: ImageCodec = browserCodec): Promise<Blob> => {
	try {
		const image = await codec.decode(file)
		try {
			const size = fitInside(image.width, image.height, MAX_UPLOAD_DIMENSION)
			const resized = await codec.encode(image.source, size, JPEG_QUALITY)
			return resized.size < file.size ? resized : file
		} finally {
			image.close()
		}
	} catch {
		return file
	}
}
